<template>
  <div
    class="header bg-white m-auto text-center px-8 py-5 flex items-center justify-between fixed top-0 left-0 right-0 z-20 lg:justify-start lg:py-0"
    :class="{ headerShadow: headerShadow }"
  >
    <div class="flex items-center">
      <div class="w-20" @click="$store.commit('setError404', false)">
        <router-link :to="{ name: 'Home' }">
          <img
            src="../assets/logo_esri.png"
            alt="Conferencia Esri España 2020"
          />
          <!-- <LogoEsriSpain /> -->
        </router-link>
      </div>
    </div>

    <div @click="$store.commit('toggleMenu')">
      <BaseIcon class="cursor-pointer text-xl lg:hidden" name="bars" />
    </div>

    <!-- <div v-else>
      <nav class="flex">
        <div class="nav-link-container">
          <router-link :to="{ name: 'Login' }" class="nav-link">
            Acceder
          </router-link>
        </div>
        <div class="nav-link-container">
          <router-link :to="{ name: 'Register' }" class="nav-link">
            Regístrate
          </router-link>
        </div>
      </nav>
    </div> -->

    <TheNav />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheNav from '@/components/TheNav'
// import LogoEsriSpain from '@/components/LogoEsriSpain'

export default {
  components: { TheNav },

  data() {
    return {
      headerShadow: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['userIsAuthenticated']),
  },

  mounted() {
    this.setHeaderShadow()
    window.addEventListener('scroll', () => {
      this.setHeaderShadow()
    })
  },

  methods: {
    setHeaderShadow() {
      window.scrollY > 0
        ? (this.headerShadow = true)
        : (this.headerShadow = false)
    },
  },
}
</script>

<style scoped>
.header {
  transition: box-shadow 0.3s;
}

.headerShadow {
  box-shadow: 0 1px 0 0 #dadce0, 0 2px 6px 0 rgba(0, 0, 0, 0.12);
}
</style>
